<template>
  <div>
    <el-tree :data="refines" :props="defaultProps"
             style="overflow-x: auto;height: 400px"
             @current-change="handleNodeClick"
             :expand-on-click-node="false"
             v-loading="loading"
             :check-strictly="false"
             node-key="id"
             default-expand-all
             :highlight-current="true"
             ref="tree">
    </el-tree>
  </div>
</template>
<script>
export default {
  name: 'refine-tree',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    refines: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      selRefine: null
    }
  },
  methods: {
    init () {
      this.selRefine = this.value
      this.$nextTick(() => {
        this.$refs.tree.setCurrentNode(this.value)
      })
    },
    handleNodeClick (val) {
      if (val.children.length > 0) {
        this.$message.info('请选中具体的细化分类（叶子节点）')
        // this.selRefine = {}
        this.selRefine.name = ''
        this.selRefine.id = ''
        this.selRefine.fullName = ''
        return
      }
      this.selRefine.name = val.name
      this.selRefine.id = val.id
      this.selRefine.fullName = val.fullName
    }
  },
  watch: {
    value (newValue) {
      this.selRefine = newValue
    },
    selRefine (newValue) {
      this.$emit('input', newValue)
      this.$emit('change')
    }
  }
}
</script>
